<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <a-tabs >
        <a-tab-pane key="1" tab="优惠券统计">
          <statisticsList></statisticsList>
        </a-tab-pane>
        <a-tab-pane key="2" tab="优惠券明细">
          <detailedList></detailedList>
        </a-tab-pane>
      </a-tabs>
    </a-card>
  </a-layout>
</template>
<script>
import { onMounted,inject,reactive, toRefs } from "vue";

import detailedList from './components/statistics/detailed';
import statisticsList from './components/statistics/statistics';
export default {
  components: {detailedList,statisticsList },
  setup(props) {
    const state = reactive({

    });
    const $router = inject('$router')
    const $Modal = inject('$Modal')
    
    onMounted(() => {
    });
    return {
      ...toRefs(state)
    };
  },
};
</script>